export const questions = [
    {
        question: "Did the clinician provide safe patient care?",
        description: "(As evidenced by safe patient outcomes, competency in job role and adherence to hospital policies and procedures)",
        name: "SafeCareLevel",
    },
    {
        question: "Was the clinician dependable?",
        description: "(As evidenced by attendance, punctuality, and ability to meet deadlines)",
        name: "DependableLevel",
    },
    {
        question: "Was the clinician professional?",
        description: "(As evidenced by appearance, attitude, and ability to work with others)",
        name: "ProfessionalLevel",
    },
    {
        question: "Was the clinician cooperative and flexible as a team member?",
        description: "(As evidenced by ability to work with others, willingness to help, and ability to adapt to change)",
        name: "CooperativeLevel",
    },
    {
        question: "Was the clinician a strong communicator?",
        description: "(As evidenced by ability to communicate effectively with patients, families, and staff)",
        name: "CommunicatorLevel",
    },
    {
        question: "How was the clinician's attendance and punctuality?",
        description: "(As evidenced by arriving to the unit on time. Limiting call-ins. Notifying the facility of call-ins, and when running late)",
        name: "AttendanceLevel",
    },
    {
        question: "Was the clinician an asset to your facility/medical team?",
        description: "(As evidenced by performing safe, quality, and professional medical care, while contributing to a positive staff culture)",
        name: "AssetLevel",
    }    
]
export const supervisor = [
    {
        question: "Supervisor Name",
        id: "supervisor-name",
        name: "SupervisorName",
        MobileDisplayOrder: 1,
        DesktopDisplayOrder: 1,
        isPlaceholder: false
    },
    {
        question: "Supervisor Title",
        id: "supervisor-title",
        name: "SupervisorTitle",
        MobileDisplayOrder: 2,
        DesktopDisplayOrder: 3,
        isPlaceholder: false
    },
    {
        question: "Reference Date",
        id: "reference-date",
        name: "ReferenceDate",
        MobileDisplayOrder: 3,
        DesktopDisplayOrder: 2,
        isPlaceholder: false
    },
    {
        question: "Facility Name",
        id: "facility-name",
        name: "FacilityName",
        MobileDisplayOrder: 4,
        DesktopDisplayOrder: 5,
        isPlaceholder: false
    },
    {
        question: "City, State",
        id: "city-state",
        name: "CityState",
        MobileDisplayOrder: 5,
        DesktopDisplayOrder: 6,
        isPlaceholder: false
    },
    {
        question: "Start Date",
        id: "reference-start-date",
        name: "StartDate",
        MobileDisplayOrder: 6,
        DesktopDisplayOrder: 7,
        isPlaceholder: false
    },
    {
        question: "End Date",
        id: "reference-end-date",
        name: "EndDate",
        MobileDisplayOrder: 7,
        DesktopDisplayOrder: 8,
        isPlaceholder: false
    }
]

export const staffingTypes = [ 
    { label: "Select...", value: "0" }, 
    { label: "Core (Full Time)", value: "1" }, 
    { label: "Core (Part-Time)", value: "4" }, 
    { label: "Travel", value: "2" }, 
    { label: "Per-Diem", value: "3" } 
];

export const evalSelectOptions = [
    { label: "Select...", value: 0 },
    { label: "Did Not Observe", value: 1 },
    { label: "Needs Improvement", value: 2 },
    { label: "Met Expectations", value: 3 },
    { label: "Exceeds Expectations", value: 4 }
];